/** Stable ids for `aria-controls` on wishlist triggers and the overlays they open. */
export const WISHLIST_SELECTION_DRAWER_ID = 'wishlist-selection-drawer';
export const WISHLIST_LOGIN_DRAWER_ID = 'wishlist-login-drawer';

/** `controlsId` is the id of the overlay this trigger opened, when that overlay is open. */
export function wishlistSelectionTriggerA11y(controlsId: string | undefined): {
    'aria-haspopup': 'dialog';
    'aria-controls'?: string;
} {
    return {
        'aria-haspopup': 'dialog',
        ...(controlsId ? { 'aria-controls': controlsId } : {}),
    };
}
